import React, {useEffect} from "react";
import ProfileHeader from "../Headers/ProfileHeader";

function Admin(props: { cognitoUser: any }) {
  const {cognitoUser} = props;
  useEffect(() => {
      refreshAllowedDomains();
    }, []
  )

  function refreshAllowedDomains() {

  }

  return (
    <>
      <ProfileHeader cognitoUser={cognitoUser} title="Admin" linkToHome="/"/>
      <section className="container main library p-4 rounded">
        <h2>Allowed domains</h2>
      </section>

      <section className="container main library p-4 rounded">
        <h2>Allowed emails</h2>
      </section>
    </>
  );
}

export default Admin;
